import Vue from "vue";
import i18n from "@/i18n";
// let xlsx = require("json-as-xlsx");
// import { utils, writeFile } from "xlsx";

function downloadFile(blobFile, name, download = true) {
  let reader = new FileReader();
  reader.readAsDataURL(blobFile);
  reader.onloadend = function () {
    let base64data = reader.result;
    console.log(base64data);
    const a = document.createElement("a");
    a.href = base64data;
    a.target = "_blank";
    if (download) a.download = name;
    a.click();
    Vue.$toast.open({
      message: i18n.t("form.success.download"),
      dismissible: true,
      type: "success"
    });
  }

}


export { downloadFile };
